import { Box, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { usePostsContext } from '../../../context/PostsProvider';
import { Post } from '../../../models/Post';
import { PostCard } from '../PostCard/PostCard';
import { PostDetailsDialog } from '../PostDetailsDialog/PostDetailsDialog';

export const TimelineComponent = () => {
  const { posts, loadMorePosts } = usePostsContext();
  const [postDetails, setPostDetails] = useState<Post | null>(null);

  const handlePostDetails = (post: Post) => {
    setPostDetails(post);
  };

  useEffect(() => {
    loadMorePosts();
  }, []);

  return (
    <>
      <InfiniteScroll
        dataLength={posts?.length || 0}
        next={loadMorePosts}
        hasMore={true}
        loader={<></>}
        endMessage={<p>Não há mais itens para carregar</p>}
      >
        <Stack spacing={2} overflow="visible">
          {posts?.length > 0 ? (
            posts?.map((post, index) => <PostCard post={post} key={index} onClick={() => handlePostDetails(post)} />)
          ) : (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
              <Typography variant="h5" color="primary">
                Nenhuma publicação disponível
              </Typography>
            </Box>
          )}
        </Stack>
      </InfiniteScroll>
      {postDetails?.id && <PostDetailsDialog post={postDetails} onClose={() => setPostDetails(null)} />}
    </>
  );
};
